import React, { useState } from "react";
import { useMusicalSelector as useSelector, useMusicalDispatch as useDispatch } from "../../../TrainingConfiguration";
import { mainActions } from "../../../../store";

import classes from "./IntervalColors.module.css";
import { intervalLabels } from "../intervalLabels";
import ColorPickerDialog from "../../../ColorPickerDialog/ColorPickerDialog";

const IntervalColors = ({ accessible = false }) => {
  const tinyScreen = useSelector((state) => state.tinyScreen);

  const index = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  const colors = useSelector((state) => state.intervalColors);
  const dispatch = useDispatch();

  const [pickerColor, setPickerColor] = useState("black");
  const [showPicker, setShowPicker] = useState([false, 0]);

  const onClickHandler = (event) => {
    const index = +event.currentTarget.id;
    setPickerColor(colors[index]);
    setShowPicker([true, index]);
  };

  const Swatch = accessible ? "button" : "div";
  const boxes = index.map((index) => {
    return (
      <td key={`${index}`}>
        <Swatch
          type={accessible ? "button" : undefined}
          aria-label={accessible ? `${intervalLabels[index]} colour` : undefined}
          id={index}
          onClick={onClickHandler}
          className={classes.square}
          style={{ backgroundColor: colors[index] }}
        ></Swatch>
      </td>
    );
  });

  const onDialogCloseHandler = (incolor) => {
    const color = incolor;
    //console.log("the color picked is");
    //console.log(color);
    dispatch(
      mainActions.setIntervalColor({ index: showPicker[1], color: color })
    );
    setShowPicker([false, 0]);
  };

  return (
    <tr>
      <td>{tinyScreen ? "Col." : "Color"}</td>
      {boxes}
      {showPicker[0] && (
        <ColorPickerDialog color={pickerColor} onClose={onDialogCloseHandler}
          accessibleLabel={accessible ? `${intervalLabels[showPicker[1]]} colour` : undefined} />
      )}
    </tr>
  );
};

export default IntervalColors;
